import { render, staticRenderFns } from "./account-report-detail.vue?vue&type=template&id=d45efc2a&"
import script from "./account-report-detail.vue?vue&type=script&lang=ts&"
export * from "./account-report-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports